import { render, staticRenderFns } from "./Candlestick.vue?vue&type=template&id=c6867f62&"
import script from "./Candlestick.vue?vue&type=script&lang=js&"
export * from "./Candlestick.vue?vue&type=script&lang=js&"
import style0 from "./Candlestick.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports